// Shared display labels for scheduled-report rows and cards. Keeping them
// here means a backend enum change (e.g. a new ReportType) is a one-file
// edit instead of two.

export const REPORT_TYPE_LABELS: Record<string, string> = {
  UsageSummary: 'Usage Summary',
  Billing: 'Billing',
  AlarmHistory: 'Alarm History',
};

export const FREQUENCY_LABELS: Record<string, string> = {
  daily: 'Daily',
  weekly: 'Weekly (Monday)',
  monthly: 'Monthly (1st)',
};
